import axiosInstance from './axiosInstance';

const incomingMailService = {
    async uploadScan(formData) {
        try {
            const response = await axiosInstance.post('/agents/incoming-mail/upload-scan', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error uploading scan:', error);
            throw error.response?.data || error;
        }
    },
    async uploadIncomingMail(formData) {
        try {
            const response = await axiosInstance.post('/agents/incoming-mail/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error uploading incoming mail:', error);
            throw error.response?.data || error;
        }
    },

    async getIncomingMail() {
        try {
            const response = await axiosInstance.get('/agents/incoming-mail');
            return response.data;
        } catch (error) {
            console.error('Error getting incoming mail:', error);
            throw error.response?.data || error;
        }
    },

    async getPendingMail(agentId) {
        try {
            const response = await axiosInstance.get('/agents/incoming-mail/pending', {
                params: { agentId }
            });
            return response;
        } catch (error) {
            console.error('Error getting pending mail:', error);
            throw error.response?.data || error;
        }
    },

    async getBusinessMail(businessId) {
        try {
            const response = await axiosInstance.get(`/agents/incoming-mail/business/${businessId}`);
            return response.data;
        } catch (error) {
            console.error('Error getting business mail:', error);
            throw error.response?.data || error;
        }
    },

    async scanMail(mailId) {
        try {
            const response = await axiosInstance.post(`/agents/incoming-mail/${mailId}/scan`, {
                status: 'Scan_requested',
                lastActionDate: new Date().toISOString(),
                lastActionBy: 'agent'
            });
            return response.data;
        } catch (error) {
            console.error('Error scanning mail:', error);
            throw error.response?.data || error;
        }
    },

    async forwardMail(mailId, forwardDetails) {
        try {
            const response = await axiosInstance.post(`/agents/incoming-mail/${mailId}/forward-request`, forwardDetails);
            return response.data;
        } catch (error) {
            console.error('Error forwarding mail:', error);
            throw error.response?.data || error;
        }
    },

    async shredMail(mailId, shredDetails) {
        try {
            const response = await axiosInstance.post(`/agents/incoming-mail/${mailId}/shred-request`, shredDetails);
            return response.data;
        } catch (error) {
            console.error('Error shredding mail:', error);
            throw error.response?.data || error;
        }
    },

    async downloadAttachment(attachmentPath) {
        try {
            const response = await axiosInstance.get(`/agents/incoming-mail/download`, {
                params: { path: attachmentPath },
                responseType: 'blob'
            });

            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', attachmentPath.split('/').pop());
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            return true;
        } catch (error) {
            console.error('Error downloading attachment:', error);
            throw error.response?.data || error;
        }
    }
};

export default incomingMailService;